//  currently the statuses map perfectly but use a map in case that changes?
export const shipmentStatusToLineStatusMap: { [index: number]: number } = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
};
